import Vue from 'vue';
import Router from 'vue-router';

import SignIn from '@/pages/SignIn.vue';
import Search from '@/pages/search/index.vue';
import Dashboard from '@/pages/Dashboard.vue';
import InstallationDetails from '@/pages/InstallationDetails.vue';
import Contact from '@/pages/Contact.vue';
import PhotoLibrary from '@/pages/PhotoLibrary.vue';
import Maps from '@/pages/Maps.vue';
import Projects from '@/pages/projects';
import ServiceList from '@/pages/service/ServiceList.vue';
import ServiceDetail from '@/pages/service/ServiceDetail.vue';

Vue.use(Router);

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  // scroll to top on route change
  scrollBehavior(/* to, from, savedPosition */) {
    return { x: 0, y: 0 };
  },
  routes: [
    {
      path: '/inloggen',
      name: 'signIn',
      component: SignIn,
    },
    {
      path: '/dashboard',
      name: 'dashboard',
      component: Dashboard,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/projecten',
      component: Projects,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/zoeken',
      component: Search,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/contact',
      name: 'contact',
      component: Contact,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/bibliotheek',
      name: 'library',
      component: PhotoLibrary,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/indebuurt',
      name: 'maps',
      component: Maps,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/installatie/:id',
      name: 'installation-details',
      component: InstallationDetails,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/service',
      name: 'service',
      component: ServiceList,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/service/:id',
      name: 'service-detail',
      component: ServiceDetail,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '*',
      redirect: '/dashboard',
    },
  ],
});
